import { BoxSkeleton } from '@common-components';

export default function ListItemSkeleton({ index }: { index?: number }) {
  return <BoxSkeleton index={index} sx={{ width: 1, height: 50 }} isLoading />;
}
